module.exports = __webpack_public_path__ + "img/winner-bg.a283c0c6.svg";